module.exports = __webpack_public_path__ + "img/ic_photos_tile.3509af0b.svg";